"use client";

import type { ErrorInfo } from "next/error";
import { ErrorPageNavBar } from "@portal/app/_components/ui-elements/CustomerNavBar/ErrorPageNavBar";
import { Layout } from "@portal/app/_components/ui-elements/Layout";
import { DreamRecoverableError } from "@portal/app/_components/DreamRecoverableErrorBoundary";

export default function Error({ error, retry }: ErrorInfo) {
  return (
    <Layout nav={<ErrorPageNavBar />} showDisclaimer={false}>
      <DreamRecoverableError error={error} retry={retry} />
    </Layout>
  );
}
